export type PlanningObjectiveStatusId =
  | 'Draft'
  | 'Active'
  | 'Achieved'
  | 'NotAchieved'
  | 'Cancelled';

export type PlanningStatusBadgeConfig = {
  label: string;
  className: string;
};

const OBJECTIVE_STATUS_CONFIG: Record<PlanningObjectiveStatusId, PlanningStatusBadgeConfig> = {
  Draft: { label: 'Rascunho', className: 'bg-slate-100 text-slate-700 ring-slate-200' },
  Active: { label: 'Ativo', className: 'bg-sky-100 text-sky-800 ring-sky-200' },
  Achieved: { label: 'Atingido', className: 'bg-emerald-100 text-emerald-800 ring-emerald-200' },
  NotAchieved: { label: 'Não atingido', className: 'bg-amber-100 text-amber-800 ring-amber-200' },
  Cancelled: { label: 'Cancelado', className: 'bg-rose-100 text-rose-800 ring-rose-200' },
};

const WORK_ITEM_STATUS_CONFIG: Record<string, PlanningStatusBadgeConfig> = {
  Planned: { label: 'Planejada', className: 'bg-slate-100 text-slate-700 ring-slate-200' },
  InProgress: { label: 'Em andamento', className: 'bg-sky-100 text-sky-800 ring-sky-200' },
  Completed: { label: 'Concluída', className: 'bg-emerald-100 text-emerald-800 ring-emerald-200' },
  Cancelled: { label: 'Cancelada', className: 'bg-rose-100 text-rose-800 ring-rose-200' },
  Overdue: { label: 'Atrasada', className: 'bg-amber-100 text-amber-800 ring-amber-200' },
  NotStarted: { label: 'Não iniciada', className: 'bg-violet-100 text-violet-800 ring-violet-200' },
  Abandoned: { label: 'Abandonada', className: 'bg-orange-100 text-orange-800 ring-orange-200' },
};

const CYCLE_STATUS_CONFIG: Record<string, PlanningStatusBadgeConfig> = {
  Draft: { label: 'Rascunho', className: 'bg-slate-100 text-slate-700 ring-slate-200' },
  Active: { label: 'Ativo', className: 'bg-sky-100 text-sky-800 ring-sky-200' },
  Closed: { label: 'Encerrado', className: 'bg-emerald-100 text-emerald-800 ring-emerald-200' },
  Cancelled: { label: 'Cancelado', className: 'bg-rose-100 text-rose-800 ring-rose-200' },
};

export function getPlanningObjectiveStatusConfig(status: string): PlanningStatusBadgeConfig {
  return OBJECTIVE_STATUS_CONFIG[status as PlanningObjectiveStatusId] ?? {
    label: status,
    className: 'bg-secondary-100 text-secondary-700 ring-secondary-200',
  };
}

export function getPlanningWorkItemStatusConfig(status: string): PlanningStatusBadgeConfig {
  return WORK_ITEM_STATUS_CONFIG[status] ?? {
    label: status,
    className: 'bg-secondary-100 text-secondary-700 ring-secondary-200',
  };
}

export function getPlanningCycleStatusConfig(status: string): PlanningStatusBadgeConfig {
  return CYCLE_STATUS_CONFIG[status] ?? {
    label: status,
    className: 'bg-secondary-100 text-secondary-700 ring-secondary-200',
  };
}

export function formatPlanningObjectiveStatus(status: string): string {
  return getPlanningObjectiveStatusConfig(status).label;
}
